import React from 'react'
import { BsFacebook,BsInstagram } from "react-icons/bs";
import { AiOutlineLinkedin,AiOutlineYoutube } from "react-icons/ai";
const Menu = () => {
  return (
    <div className="responsive-sidebar-menu">
    <div className="overlay" />
    <div className="sidebar-menu-inner">
      <div className="menu-wrap">
        <p>Menu</p>
        <ul className="menu scroll-nav-responsive d-flex">
          <li>
            <a className="scroll-to" href="#home">
              <i className="las la-home" /> <span>Home</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#skills">
              <i className="las la-shapes" /> <span>Skills</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#about">
              <i className="lar la-user" /> <span>About</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#resume">
              <i className="las la-briefcase" /> <span>Resume</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#services">
              <i className="las la-stream" /> <span>SkillBar</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#portfolio">
              <i className="las la-grip-vertical" /> <span>Portfolios</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#testimonial">
              <i className="lar la-comment" /> <span>Testimonial</span>
            </a>
          </li>
          <li>
            <a className="scroll-to" href="#contact">
              <i className="las la-envelope" /> <span>Contact</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="sidebar-social">
        <p>Social</p>
        <ul className="social-links d-flex align-items-center">
        <li>
        <a target='_blank' href="https://www.facebook.com/profile.php?id=100092541834834&mibextid=ZbWKwL"><BsFacebook size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.instagram.com/ajaybairwa4273/"><BsInstagram size={27} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.linkedin.com/in/ajay-bairwa-269921280/"><AiOutlineLinkedin size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.youtube.com/@WebMastery009/about"><AiOutlineYoutube size={36}/></a>
      </li>
        </ul>
      </div>
    </div>
  </div>
  )
}

export default Menu